<div class="modal-header">
  <h4 class="modal-title"><i class="fa fa-upload"></i> Upload APK File</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="upload-form">
    <!-- File Upload -->
    <div class="form-group">
      <label><i class="fa fa-android"></i> Android APK File <span class="required">*</span></label>
      <div class="file-upload-area" (click)="browseFiles()">
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept=".apk,application/vnd.android.package-archive"
          hidden
          [disabled]="isSubmitting"
        />
        <div *ngIf="!selectedFile" class="upload-placeholder">
          <i class="fa fa-upload"></i>
          <p>Click to browse and select an APK file</p>
          <small>Only APK files are accepted</small>
        </div>
        <div *ngIf="selectedFile" class="file-selected">
          <div class="file-info">
            <i class="fa fa-android file-icon"></i>
            <div class="file-details">
              <span class="file-name">{{ selectedFile.name }}</span>
              <span class="file-size">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</span>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-danger"
            (click)="removeFile()"
            [disabled]="isSubmitting"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="info-message">
      <i class="fa fa-info-circle"></i>
      <span>The APK file will be uploaded to AWS S3 and made available for download.</span>
    </div> -->
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="isSubmitting">
    Cancel
  </button>
  <button class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting || !selectedFile">
    <i class="fa" [ngClass]="{ 'fa-spinner fa-spin': isSubmitting, 'fa-upload': !isSubmitting }"></i>
    <span class="ml-1">Upload</span>
  </button>
</div>


